import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import { HUMANIZE_PROVIDER } from "constants/vcsProviders";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import { OriginIntegration, VcsProvider } from "types/generated";

import {
  ORIGIN_INTEGRATION_DESCRIPTION,
  ORIGIN_INTEGRATION_NAME,
} from "../../shared/VcsList/constants";
import { getIntegrationDetails } from "../../shared/VcsShared/components/Details/helpers";
import VCSProviderIcon from "../../shared/VcsShared/components/ProviderIcon";

type VCSIntegrationsOriginDetailsDrawerProps = {
  details: OriginIntegration | undefined;
  onClose?: () => void;
};

const VCSIntegrationsOriginDetailsDrawer = createDrawer(
  ({ details, onClose }: VCSIntegrationsOriginDetailsDrawerProps) => {
    return (
      <DrawerSimple onClose={onClose}>
        {details && (
          <>
            <DrawerHeader justify="between">
              <DrawerHeaderTitle title="Source code details" />
              <DrawerCloseIcon />
            </DrawerHeader>

            <DrawerBody>
              <FormField label="Provider">
                <Box gap="medium">
                  <VCSProviderIcon provider={VcsProvider.Origin} />

                  <Typography tag="span" variant="p-body2">
                    {HUMANIZE_PROVIDER[VcsProvider.Origin]}
                  </Typography>
                </Box>
              </FormField>

              <FormFieldViewText label="Integration name" value={ORIGIN_INTEGRATION_NAME} />

              {getIntegrationDetails(details)}

              <DescriptionDetails description={ORIGIN_INTEGRATION_DESCRIPTION} />
            </DrawerBody>
          </>
        )}
      </DrawerSimple>
    );
  }
);

export const showVCSIntegrationsOriginDetailsDrawer = createDrawerTrigger(
  VCSIntegrationsOriginDetailsDrawer
);
